import * as axios from 'axios'
import { mobileBackendUrl } from '../env'
import { logEvent } from './logUtility'
import { getAuthHeaders, getSecondaryAuthHeaderObject } from './sessionStorage'
import { postResponse } from './appBridge'

const mbBaseUrl = mobileBackendUrl
const axiosInstance = axios.default.create({
  baseURL: mbBaseUrl as string
})

axiosInstance.interceptors.request.use(
  (request) => {
    const authHeaders = getAuthHeaders()
    const secondaryAuthHeaderObject = getSecondaryAuthHeaderObject()

    const {
      authorization = '',
      'os-type': OSType = '',
      'os-version': OSVersion = '',
      'app-version': appVersion = '',
      'app-type': appType = '',
      'fingerprint-id': fingerprintJsId = ''
    } = authHeaders || {}

    // add headers to request when available
    if (authorization) {
      request.headers['Authorization'] = authorization
      request.headers['os-type'] = OSType
      request.headers['os-version'] = OSVersion
      request.headers['app-version'] = appVersion
      request.headers['app-type'] = appType
      request.headers['fingerprint-id'] = fingerprintJsId
    }

    if (secondaryAuthHeaderObject) {
      Object.entries(secondaryAuthHeaderObject)?.forEach(([key, value]) => {
        request.headers[key] = value
      })
    }

    logEvent('info', {
      message: 'API Request Initiated',
      url: request.url,
      method: request.method,
      data: request.data,
      headers: request.headers
    })
    return request
  },
  (error) => {
    logEvent('error', {
      message: 'API Request Error',
      error: error.message
    })
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    logEvent('info', {
      message: 'API Response Received',
      url: response.config.url,
      method: response.config.method,
      status: response.status,
      data: response.data,
      headers: response.headers
    })

    if (response?.data?.responseType === 'REDIRECTION_WITH_ACCESS_TOKEN_RESPONSE') {
      postResponse(JSON.stringify(response?.data))
    }

    return response
  },
  (error) => {
    logEvent('error', {
      message: 'API Response Error',
      url: error.config?.url || 'Unknown URL',
      method: error.config?.method || 'Unknown Method',
      status: error.response?.status || 'No Status',
      error: error.message,
      headers: error?.response?.headers || error.config?.headers || {}
    })

    return Promise.reject(error)
  }
)

export default axiosInstance
